"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initIframeSync = initIframeSync;
const DDT_DOMAINS = ['sta.sh', 'deviantart.com'];
const domainRegex = new RegExp(`^(https?:)?\\/\\/([^.]+\\.)?(${DDT_DOMAINS.join('|').replace('.', '\\.')})\\b`, 'i');
function initIframeSync(logger, watcher) {
    new IframeSyncKeeper(logger, watcher);
}
class IframeSyncKeeper {
    logger;
    watcher;
    // counter to keep track of the "version" of the channels list
    // used to keep consistentcy between all frames using postMessage
    version = 0;
    constructor(logger, watcher) {
        this.logger = logger;
        this.watcher = watcher;
        window.addEventListener('message', this.onSyncMessage);
    }
    syncWatched = () => {
        const msg = JSON.stringify({
            ddt: true,
            version: this.version,
            channels: this.watcher.watching(),
        });
        const origin = '*';
        const iframes = getIframes();
        if (iframes.length) {
            this.logger.log(`syncing channels down - ${iframes.length} frames found`);
            iframes.forEach(element => {
                // CI seems flaky on this line, so going really really safe...
                element &&
                    element.contentWindow &&
                    element.contentWindow.postMessage &&
                    element.contentWindow.postMessage(msg, origin);
            });
        }
        if (isCurrentInstanceInIframe()) {
            this.logger.log('syncing channels up');
            window.parent.postMessage(msg, origin);
        }
    };
    onSyncMessage = (event) => {
        const data = getMessageData(event);
        if (!data || this.version === data.version) {
            return; // not a DDT postMessage, or already in sync
        }
        this.version = data.version; // update version
        this.watcher.setWatched(data.channels); // overwrite watched list
        this.logger.log(`updated watch list to v${data.version} in ${window.name}`, this.watcher.watching());
        this.syncWatched(); // continue passing the message
    };
}
function validateOrigin(url) {
    return domainRegex.test(url);
}
function isCurrentInstanceInIframe() {
    return window.parent !== window;
}
function validateMessageEvent(event) {
    return event && event.data && event.origin && validateOrigin(event.origin);
}
function validateMessageData(data) {
    return data && data.ddt && data.version;
}
function getMessageData(event) {
    if (!validateMessageEvent(event)) {
        return;
    }
    try {
        const data = JSON.parse(event.data);
        if (validateMessageData(data)) {
            return data;
        }
    }
    catch (x) {
        // not our data
    }
}
function getIframes() {
    const frames = Array.prototype.slice.call(document.querySelectorAll('iframe[src]'));
    // only include frames that are part of DDT domains
    return frames.filter(frame => validateOrigin(frame.src));
}
//# sourceMappingURL=iframe.js.map